<template>
  <transition name="fade">
    <div v-if="visible" class="global-loading">
      <div class="loading-box">
        <div class="spinner"></div>
        <p>{{ text }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      text: "加载中...",
      originalBodyOverflow: "", // 保存原始 overflow 值
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        // 弹窗显示：禁止背景滚动
        this.disableBodyScroll();
      } else {
        // 弹窗隐藏：恢复背景滚动
        this.enableBodyScroll();
      }
    },
  },
  
  mounted() {
    // 如果组件创建时 visible 默认为 true，也需要禁止滚动（但一般初始为 false）
    if (this.visible) {
      this.disableBodyScroll();
    }
  },
  beforeDestroy() {
    // 组件销毁前确保恢复滚动（防止组件被强行移除时滚动仍被禁用）
    this.enableBodyScroll();
  },
  methods: {
    // 开启Loading
    open(text = "加载中...") {
      this.text = text;
      this.visible = true;
    },
    // 关闭Loading
    close() {
      this.visible = false;
    },
    
    disableBodyScroll() {
      // 保存当前 body 的 overflow 样式（可能为空或已有值）
      this.originalBodyOverflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
    },
    enableBodyScroll() {
      // 恢复原来的 overflow 样式
      document.body.style.overflow = this.originalBodyOverflow;
      // 清除保存的值（可选）
      this.originalBodyOverflow = "";
    },
  }
}
</script>

<style scoped>
.global-loading {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}
.loading-box {
  /* background: #fff; */
  /* padding: 30px;
  border-radius: 8px; */
  text-align: center;
  font-size: 1.6rem;
  color: #fff;
}
.spinner {
  width: 6rem;
  height: 6rem;
  border: 0.5rem solid #fff;
  border-top: 0.5rem solid #409eff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>